import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { LoadingView } from '@common/views';
import { AppTheme } from '@app/components/AppTheme';
import { store } from '../../slices/store';
import AppRoutes from '../../routes/index';
import '@common/config/i18n';
import './App.scss';

export default function App() {
  return (
    <Provider store={store}>
      <AppTheme />
      <Suspense fallback={<LoadingView />}>
        <AppRoutes />
      </Suspense>
    </Provider>
  );
}
